export default "__VITE_ASSET__09cecd35__"